import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { useToggle } from '~/hooks';
import { useNavigationDetector } from '~/hooks/useNavigationDetector';

export const useReviewNavigation = () => {
  const navigate = useNavigate();

  const [showNavigationGuard, navigationGuardControls] = useToggle();

  const onNavigationAttempt = useCallback(() => {
    navigationGuardControls.setOn();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- Stable callback: useToggle controls are stable refs
  }, []);

  const { allowNavigation, navigateToPending, clearPendingNavigation } = useNavigationDetector({
    when: true,
    onNavigationAttempt,
  });

  const handleBack = useCallback(() => {
    allowNavigation();
    navigate('/dashboard/multi-day/add-invites');
  }, [allowNavigation, navigate]);

  const handleEditShift = useCallback(
    (dateIndex: number) => {
      allowNavigation();
      navigate(`/dashboard/multi-day/edit-shift/${dateIndex}`);
    },
    [allowNavigation, navigate],
  );

  const cancelRequest = useCallback(() => {
    allowNavigation();
    navigate('/');
  }, [allowNavigation, navigate]);

  const redirectToSelectDates = useCallback(() => {
    allowNavigation();
    navigate('/dashboard/shift-request/select-dates', { replace: true });
  }, [allowNavigation, navigate]);

  return {
    showNavigationGuard,
    navigationGuardControls,
    allowNavigation,
    navigateToPending,
    clearPendingNavigation,
    handleBack,
    handleEditShift,
    cancelRequest,
    redirectToSelectDates,
  };
};
